export default "__VITE_ASSET__5a12f9bd__"